import { pickPlatformValue } from '../../utils';

/* eslint-disable-next-line */
export interface SpinnerProps {
    height?: number;
    width?: number;
    color?: string;
}

type stylesType = {
    height?: number;
    width?: number;
    borderLeftColor?: string;
    borderRightColor?: string;
    borderBottomColor?: string;
    borderTopColor: string;
};
const blueColor = pickPlatformValue({ branded: 'primary-600', stork: 'variant-900', fallback: 'blue-500' });

export function Spinner(props: SpinnerProps) {
    let styleCustom: stylesType = { borderTopColor: 'transparent' };
    Object.keys(props).forEach((key) => {
        const value = props[key as keyof SpinnerProps];
        if (key === 'color') {
            styleCustom = {
                ...styleCustom,
                borderLeftColor: value as string,
                borderRightColor: value as string,
                borderBottomColor: value as string,
            };
        } else {
            styleCustom = { ...styleCustom, [key]: value };
        }
    });
    return (
        <div
            style={styleCustom}
            className={`w-16 h-16 border-4 border-${blueColor} border-solid rounded-full animate-spin`}
        ></div>
    );
}

export default Spinner;
